export default __webpack_public_path__ + "static/media/Image-20.ed676656.png";